import { Component as ComponentContainer } from '@styles/layout';
import { VideoGuideComponent, PageTemplates } from '@model/content';
import { VideoGuides, VideoGuideList } from '@components/guides';

export const VideoGuideContainer = ({ path, tripType, guides, destination, pageType }: VideoGuideComponent) => {
  const Component = pageType === PageTemplates.LIST_PAGE ? VideoGuideList : VideoGuides;
  return (
    <ComponentContainer>
      <Component path={path} destination={destination?.display} tripType={tripType} guides={guides} />
    </ComponentContainer>
  );
};
